export enum PaymentMethod {
  WIRE = 'wire',
}
